export default __webpack_public_path__ + "static/spiritual-india-journey-2-3a08a18a8b9bc802adb55088e182b7c1.jpg";